import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import { useRouter } from 'next/router';
import Icon from '@common/assets';
import getProfileLottie from '@graphic/getProfileLottie.json';
import bangMark from '@graphic/bannerIcon.json';
import { useUserInfo } from '@repository/auth/useUserInfo';
import LoginModal from '@components/loginModal';
import { useInsightResumeLog } from '@repository/insight/useInsight';
import Colors from '@domain/constant/colors';
import useModal from '@utils/hooks/useModal';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const options1 = {
  loop: true,
  autoplay: true,
  animationData: bangMark,
};

const options2 = {
  loop: true,
  autoplay: true,
  animationData: getProfileLottie,
};

interface BannerProps {
  handleClickCareerBanner: () => void;
  handleClickResumeProfileBanner: () => void;
}

const ComponentLogId = 'btn_banner_enter_insight_resume';

const Banner = ({ handleClickCareerBanner, handleClickResumeProfileBanner }: BannerProps) => {
  const { pathname } = useRouter();
  const { mutateAsync: fetchLog } = useInsightResumeLog();
  const [activeIndex, setActiveIndex] = React.useState<number>(0);
  const { data: userInfo } = useUserInfo();
  const { openModal: openLoginModal, closeModal, isModalOpen } = useModal();
  const isLogin = !!userInfo?.id;

  const bannerEls = [
    // <button
    //   key={1}
    //   type={'button'}
    //   className={cx('banner', 'type2')}
    //   onClick={() => {
    //     if (!isLogin) {
    //       openLoginModal();
    //       return;
    //     }
    //     handleClickCareerBanner();
    //   }}
    // >
    //   <div className={cx('textArea')}>
    //     <span className={cx('title')}>내가 언제 입사했더라?</span>
    //     <span className={cx('desc')}>
    //       잊어버린 경력 쉽게 연동하기
    //       <Icon name={'arrowRightLight'} width={24} height={24} fill={Colors.C_WHITE} />
    //     </span>
    //   </div>
    //   <div className={cx('iconArea')}>
    //     <Lottie options={options1} />
    //   </div>
    // </button>,
    <button
      key={1}
      type={'button'}
      className={cx('banner', 'type3')}
      onClick={async () => {
        if (!isLogin) {
          openLoginModal();
          return;
        }
        await fetchLog({
          action: 'CLICK',
          actionSource: pathname,
          actionComponent: ComponentLogId,
        });
        handleClickResumeProfileBanner();
      }}
    >
      <div className={cx('textArea')}>
        <span className={cx('title')}>프로필을 손쉽게 채워볼까?</span>
        <span className={cx('desc')}>
          제출한 지원서 불러오기
          <Icon name={'arrowRightLight'} width={24} height={24} fill={Colors.C_WHITE} />
        </span>
      </div>
      <div className={cx('iconArea')}>
        <Lottie options={options2} />
      </div>
    </button>,
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % bannerEls.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, [bannerEls.length]);

  return (
    <div className={cx('bannerArea')}>
      {bannerEls.map((banner, index) => (
        <div
          key={index}
          className={cx('bannerWrap', {
            fadeIn: index === activeIndex,
            fadeOut: index !== activeIndex,
          })}
        >
          {banner}
        </div>
      ))}

      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={isModalOpen}
        onClose={closeModal}
      />
    </div>
  );
};

export default Banner;
